import { schemaStorageGet, schemaStorageSet } from "@ledgerhq/wallet-api-core";
export class StorageModule {
    client;
    constructor(client) {
        this.client = client;
    }
    async get(key, storeId) {
        const storageGetResult = await this.client.request("storage.get", {
            key,
            storeId,
        });
        const safeResults = schemaStorageGet.result.parse(storageGetResult);
        return safeResults.value;
    }
    async set(key, value, storeId) {
        const storageSetResult = await this.client.request("storage.set", {
            key,
            value,
            storeId,
        });
        const safeResults = schemaStorageSet.result.parse(storageSetResult);
        return safeResults;
    }
}
//# sourceMappingURL=Storage.js.map